const e = Object.freeze({
  default: "default",
  bold: "bold",
  italic: "italic",
  fixed: "fixed",
  fixedBold: "fixedBold",
  fixedItalic: "fixedItalic",
  regional: "regional",
  regionalItalic: "regionalItalic",
  serif: "serif",
  serifItalic: "serifItalic",
  subtitle: "subtitle",
  subtitleItalic: "subtitleItalic"
}), t = Object.freeze({
  none: "",
  arrow: "arrow",
  box: "box",
  caretLeft: "caret-left",
  caretRight: "caret-right",
  chart: "chart",
  check: "check",
  checkClear: "check-clear",
  checkPartial: "partial-check",
  checkmarkChecked: "checkbox-checked",
  checkmarkUnChecked: "checkbox-unchecked",
  chevronDown: "chevron-down",
  chevronLeft: "chevron-left",
  chevronRight: "chevron-right",
  close: "close",
  copy: "copy",
  download: "download",
  downloadSheet: "download-sheet",
  dragHandle: "drag-handle",
  editPencil: "edit-pencil",
  emptyCircle: "empty-circle",
  expand: "expand",
  filtersToggle: "filters-toggle",
  incomplete: "incomplete",
  infoCircle: "info-circle",
  kebab: "kebab",
  leaf: "leaf",
  littleI: "little-i",
  littleX: "little-x",
  lock: "lock",
  minus: "minus",
  minusCircleActive: "minus-circle-active",
  minusCircleInActive: "minus-circle-inactive",
  noChargeActive: "no-charge-active",
  noChargeInActive: "no-charge-inactive",
  partialCheck: "partial-check",
  pencil: "pencil",
  plus: "plus",
  restrictedActive: "restricted-active",
  restrictedCircleActive: "restricted-circle-active",
  restrictedCircleInActive: "restricted-circle-inactive",
  restrictedInActive: "restricted-inactive",
  search: "search",
  star: "star",
  table: "table",
  x: "x",
  xCircleActive: "x-circle-active",
  xCircleInActive: "x-circle-inactive"
}), c = Object.freeze({
  "1x": "1x",
  "2x": "2x",
  "3x": "3x",
  "4x": "4x",
  "5x": "5x",
  "6x": "6x",
  "7x": "7x",
  "8x": "8x",
  "9x": "9x",
  "10x": "10x",
  "11x": "11x",
  "12x": "12x"
}), i = Object.freeze({
  default: "default",
  light: "light",
  altLight: "alt-light",
  dark: "dark"
}), l = Object.freeze({
  _blank: "_blank",
  _self: "_self",
  _parent: "_parent",
  _top: "_top"
}), r = Object.freeze({
  left: "left",
  right: "right",
  top: "top",
  bottom: "bottom"
}), a = Object.freeze({
  default: "default",
  sm: "sm"
}), o = Object.freeze({
  default: "default",
  primary: "primary",
  secondary: "secondary"
}), n = Object.freeze({
  mobile: 767,
  medium: 1023,
  large: 1279,
  xl: 1919
});
export {
  a as BUTTON_PRESENTATION_SIZE,
  o as BUTTON_VARIANT,
  t as ICON_NAME,
  l as LINK_TARGET,
  n as MAX_SCREEN_WIDTH,
  c as PADDING_SIZE,
  r as PLACEMENT,
  e as PRESENTATION_STYLE,
  i as PRESENTATION_THEME_NAME
};
//# sourceMappingURL=constants.js.map
